export * from '@ms/shared-react-people-picker/lib/PeoplePickerDefaultItems';